import { Routes } from '@models/route';
import { lazy } from 'react';

const QuoteListing = lazy(() => import('@pages/quotes/QuoteList').then((p) => ({ default: p.default })));
const QuoteDetail = lazy(() =>
  import('@pages/quotes/QuoteDetail').then((p) => ({
    default: p.default
  }))
);

export const QuoteRoutes: Routes = [
  {
    path: 'admin/quotes',
    component: QuoteListing,
    children: [
      {
        path: 'create',
        component: QuoteDetail
      },
      {
        path: ':id',
        component: QuoteDetail
      }
    ]
  }
];
